import { type RenewalApproach } from 'apps/employer_renewals/types'

export const getRenewalApproachHighlights = (renewalApproach: RenewalApproach, isUsingFlatAllowances?: boolean, qmeEnabled?: boolean): string[] => {
  if (isUsingFlatAllowances) {
    return []
  }

  if (renewalApproach === 'match') {
    return [
      'Employees keep the same quality of coverage',
      ...(qmeEnabled ? ['Can afford HSA-eligible items in Marketplace'] : []),
    ]
  } else if (renewalApproach === 'upgrade') {
    return [
      'Healthier, more satisfied employees',
      ...(qmeEnabled ? ['Can afford HSA-eligible items in Marketplace'] : []),
    ]
  } else if (renewalApproach === 'reduce') {
    return [
      'Higher out-of-pocket costs and higher payroll deductions for your employees in 2026',
      "You're increasing medical expenses for your employees and their families",
    ]
  }

  return []
}
